import { Link, useNavigate } from "react-router-dom"
import { ChevronRight } from "lucide-react"
import { numberToUSD } from "../../../utils"
import Cell from "../cell"
import ScreenReaderOnly from "../../screen-reader-only"
import HeaderCell from "../header-cell"
import HeaderRow from "../header-row"
import { AllOrgsBillingData } from "../../../../types"
import If from "../../if"

interface Props {
  orgs: { id: string; name: string }[]
  systemUsage: AllOrgsBillingData
}

const OrgBillingTable = ({ orgs, systemUsage }: Props) => {
  const navigate = useNavigate()

  const onClickRow = (orgId: string) => {
    const options = {
      state: {
        usage: systemUsage[orgId][0],
        org: orgs.find(org => org.id === orgId)
      }
    }
    navigate(`/billing/${orgId}`, options)
  }

  return (
    <div className="bg-white px-8 py-12 rounded-lg">
      <table className="w-full border-collapse table-auto text-left">
        <thead>
          <HeaderRow>
            <HeaderCell>Org</HeaderCell>
            <HeaderCell className="hidden md:table-cell">Lead Total</HeaderCell>
            <HeaderCell className="hidden md:table-cell">
              Email Total
            </HeaderCell>
            <HeaderCell className="hidden md:table-cell">SMS Total</HeaderCell>
            <HeaderCell className="whitespace-nowrap">
              Invoice amount
            </HeaderCell>
            <HeaderCell>
              <ScreenReaderOnly>invoice link</ScreenReaderOnly>
            </HeaderCell>
          </HeaderRow>
        </thead>
        <tbody className="divide-y divide-zinc-200">
          {orgs.map(org => {
            const breakdown = systemUsage?.[org.id]?.[0]?.details?.breakdown
            const total = systemUsage?.[org.id]?.[0]?.details?.total

            return (
              <tr
                key={org.id}
                onClick={() => onClickRow(org.id)}
                className="cursor-pointer"
              >
                <Cell>{org.name}</Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.leads?.total ?? 0}
                </Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.emails?.total ?? 0}
                </Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.sms?.total ?? 0}
                </Cell>
                <Cell>{numberToUSD(total ?? 0)}</Cell>
                <Cell>
                  <If
                    condition={!!systemUsage?.[org.id]?.[0]?.details}
                    then={
                      <Link to={`/billing/${org.id}`}>
                        <ChevronRight size={16} />
                        <ScreenReaderOnly>
                          View invoice from {org.name}
                        </ScreenReaderOnly>
                      </Link>
                    }
                  />
                </Cell>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default OrgBillingTable
